import { Component } from '@angular/core';
import { Mainservice2Service } from 'src/app/pet/pet-layout/service/mainservice2.service';
import { ClerkNocService } from '../service/clerk-noc.service';
import { session } from 'src/environments/environment.session';
import * as numberToWords from 'number-to-words';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-noc-bill',
  templateUrl: './noc-bill.component.html',
  styleUrls: ['./noc-bill.component.css']
})
export class NocBillComponent {
  ebillUser: any;
  b_acct_id: any;
  shop_type: any = [];
  // Obj: any = {}
  constructor(public mainService: Mainservice2Service, public clerkNocService: ClerkNocService,private router : Router) { }
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    this.clerkNocService.Obj = await this.clerkNocService.Obj
    await this.filedetilas();
    await this.calculation();
  }
  async filedetilas() {
    console.log(this.clerkNocService.Obj)
    this.clerkNocService.Obj['reinfor_fees'] = 192.00
    this.clerkNocService.Obj['dump_fees'] = 40.00
    this.clerkNocService.Obj['inspection_fees'] = 20.00
  }
 async calculation(){
    this.clerkNocService.Obj['total_inspection_fees'] = Number(this.clerkNocService.Obj['inspection_fees']) * Number(this.clerkNocService.Obj['total_area'])
    this.clerkNocService.Obj['total_dump_fees'] = Number(this.clerkNocService.Obj['dump_fees']) * Number(this.clerkNocService.Obj['total_area'])
    this.clerkNocService.Obj['total_reinfor_fees'] = Number(this.clerkNocService.Obj['reinfor_fees']) * Number(this.clerkNocService.Obj['total_area'])
    this.clerkNocService.Obj['bill_amount'] = Number(this.clerkNocService.Obj['total_inspection_fees'].toFixed(2)) +Number(this.clerkNocService.Obj['total_dump_fees'].toFixed(2)) + Number(this.clerkNocService.Obj['total_reinfor_fees'].toFixed(2));
    this.clerkNocService.Obj['bill_amount'] = Math.round(this.clerkNocService.Obj['bill_amount']);
    await this.clerkNocService.convertToWords();
  }
  // ///////////////////////////////////////////////////////////////////////////////
 
  

  validateNumber(event: Event) {
    const input = event.target as HTMLInputElement;
  
    input.value = input.value.replace(/[^0-9]/g, '');
    this.clerkNocService.Obj['floor_buld_area'] = input.value;
  
  }

  preventSpecialCharacters(event: KeyboardEvent) {
    const forbiddenKeys = ['+', '-', 'e', 'E'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

// //////////////////////////////////////

back(){
  
}


}
